<template>
  <section class="container">
    <div class="inner">
      <Heading>
        <template #heading>
          キーワード<PresentIcon />を集めて<br>プレゼント抽選会に参加しよう！<br>
          <a class="link" href="/#/2021/tsuruha/present">賞品一覧をCHECK</a>
        </template>
      </Heading>
      <hr class="bold">
      <hr class="thin">
      <a class="box-wrapper" href="/#/2021/tsuruha/present">
        <ul id="box1">
          <li><img src="/img/present2021tsuruha/topHitachi.png"></li>
          <li><img src="/img/present2021tsuruha/topNikunoito.png"></li>
          <li class="last"><img src="/img/present2021tsuruha/topPot.png"></li>
        </ul>
        <div>
          <ul id="box2">
            <li><img src="/img/present2021tsuruha/topBruno.png"></li>
            <li class="last"><p>応募フォームから<br>15:00までにエントリー</p></li>
          </ul>
          <ul id="box3">
            <li><p>15:30からLIVEで<br>当選者発表</p></li>
            <li class="last"><img src="/img/present2021tsuruha/topKettle.png"></li>
          </ul>
        </div>
        <ul id="box4">
          <li><img src="/img/present2021tsuruha/topPana2.png"></li>
          <li><img src="/img/present2021tsuruha/topAndDeco.png"></li>
          <li class="last"><img src="/img/present2021tsuruha/topTanita.png"></li>
        </ul>
      </a>
      <hr class="thin">
      <hr class="bold">
    </div>
  </section>
</template>

<script>
import Heading from '@/components/atoms/Heading.vue'
import PresentIcon from '@/components/atoms/PresentIcon.vue'
import { setUrlForEvent } from '@/helpers/utils.js'
export default {
  components: {
    Heading,
    PresentIcon
  },
  mounted () {
    setUrlForEvent('presentUrl')
  }
}
</script>

<style lang="sass" scoped>
section
  background-color: $pink
  padding: 15px 0 25px
.heading
  border-radius: 10px
  color: $pink
  vertical-align: middle
  background: #fff
  .present-icon
    vertical-align: middle
    margin: 0 .3em
.link
  color: #02AC3D
  text-decoration: underline
.bold
  border: solid 3px #fff
.thin
  border: solid 1px #fff
  margin: 0px
.box-wrapper
  display: flex
  margin: 10px 0
  height: 380px
  align-items: center
  @media only screen and (max-width: 600px)
    display: block
    height: auto
  #box1
    width: 350px
    margin-right: 10px
    @media only screen and (max-width: 600px)
      display: flex
      margin-right: 0
      width: auto
    li
      margin-bottom: 10px
      @media only screen and (max-width: 600px)
        margin-right: 10px
    .last
      margin-bottom: 0
      @media only screen and (max-width: 600px)
        margin-right: 0
  div
    display: contents
    @media only screen and (max-width: 600px)
      display: flex
      margin-bottom: 10px
    #box2
      margin-right: 10px
      li
        margin-bottom: 10px
      .last
        margin-bottom: 0px
        @media only screen and (max-width: 600px)
          margin-right: 0
      p
        display: flex
        justify-content: center
        align-items: center
        color: $pink
        background-color: #fff
        overflow: hidden
        line-height: 1.6
        text-align: center
        font-size: 1.6rem
        height: 120px
        @media only screen and (max-width: 600px)
          height: 124px
    #box3
      margin-right: 10px
      @media only screen and (max-width: 600px)
        margin-right: 0
      li
        margin-bottom: 10px
      .last
        margin-bottom: 0px
      p
        display: flex
        justify-content: center
        align-items: center
        color: $pink
        background-color: #fff
        overflow: hidden
        line-height: 1.6
        text-align: center
        font-size: 1.6rem
        height: 120px
        @media only screen and (max-width: 600px)
          height: 124px
  #box4
    width: 350px
    @media only screen and (max-width: 600px)
      display: flex
      width: auto
    li
      margin-bottom: 10px
      @media only screen and (max-width: 600px)
        margin-right: 10px
        margin-bottom: 0
    .last
      margin-bottom: 0px
      @media only screen and (max-width: 600px)
        margin-right: 0
  .box
    display: flex
    justify-content: center
    align-items: center
    width: 50%
    color: $pink
    background-color: $lightpink
    overflow: hidden
    line-height: 1.6
    text-align: center
    font-size: 1.6rem
    @media only screen and (max-width: 600px)
      height: 128px
    @media only screen and (min-width: 601px)
      height: 214px
.sign-up
  text-align: center
  color: #fff
.signtitle
  color: #fff
  text-decoration: underline
  font-size: 20px
.signtxt
  font-size: 12px
  margin-top: 15px
  opacity: 0.8
</style>
